export default __webpack_public_path__ + "static/media/netflix-logo.893e75f1.png";